import React, { Component } from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import ReduxFormInput from '../../common/forms/ReduxFormInput';
import { referAFriend } from './redux/actions';
import { formatValidationErrors } from '../../common/utils/getApiReducer';

const validate = values => {
  const errors = {};

  if (!values.email || !values.email.trim()) {
    errors.email = 'Email is required.';
  }

  return errors;
};

const ReferAFriendForm = reduxForm({
  form: 'referAFriendForm',
  validate,
})(({ handleSubmit, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field name="email" component={ReduxFormInput} label="Email Address">
        <input type="text" />
      </Field>
      <Field name="message" component={ReduxFormInput} label="Message">
        <textarea rows="4" />
      </Field>
      <div className="btn-wrapper">
        <button type="submit" className="button" disabled={submitting}>
          Send Referral
        </button>
      </div>
    </form>
  );
});

class ReferAFriendWidget extends Component {
  state = {
    sent: false,
  };

  handleSubmit = values => {
    return this.props.dispatch(referAFriend(values)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.setState({ sent: true });
      }
    });
  };

  clearSent = () => {
    this.setState({ sent: false });
  };

  render() {
    const { sent } = this.state;
    return sent ? (
      <div className="refer--widget">
        <h3>Referral sent successfully!</h3>
        <div className="refer--widget-sent">
          <button className="button button--theme--outline" type="button" onClick={this.clearSent}>
            Send Another
          </button>
        </div>
      </div>
    ) : (
      <div className="refer--widget">
        <h3>Refer a Friend</h3>
        <div className="refer--widget-form">
          <p>Enter the email of a friend who would love to try Tathata Golf.</p>
          <ReferAFriendForm onSubmit={this.handleSubmit} />
        </div>
      </div>
    );
  }
}

export default connect()(ReferAFriendWidget);



// WEBPACK FOOTER //
// ./src/subscription/dashboard/ReferAFriendWidget.js